<template>
    <div>
        <div class="background">
            <!-- <div class="video_group">
                <div class="video">
                    <img src="../../assets/test.gif" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
                <div class="video">
                    <img src="https://img.18183.com/uploads/210812/374-210Q2113011394.png" alt="">
                </div>
            </div> -->

            <div style="width=100%">
                <video autoplay="autoplay" loop="loop" muted src="../../assets/bggg_1.mp4"></video>
            </div>


            <!-- <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a4.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a2.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a19.mp4" />
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a8.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a7.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a6.mp4" />
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a10.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a11.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a12.mp4" />
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a13.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a14.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a15.mp4" />
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a16.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a17.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a18.mp4" />
                </div>
            </div>
            <div class="video_group">
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a2.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a19.mp4" />
                </div>
                <div class="video">
                    <video autoplay="autoplay" loop="loop" muted src="../../assets/a5.mp4" />
                </div>
            </div> -->

        </div>
        <div class="black"></div>
        <div class="login_page">
            <div class="head">
                <div class="head_c">
                    <img class="logo" src="../../assets/login_logo.png" alt="">
                    <button class="login_btn" @click="login_box">登录</button>
                </div>
            </div>
            <div class="content">
                <div class="info_login">
                    <div class="info">
                        <!-- <h2>美好奇妙夜，抖音有你更美好</h2>
                        <p>2020年承载了国人新年的欢笑与泪点，抖音也因疫情记录下了非常多感人的内容。在即将跨入2021年的这⼀刻，抖音与国人⼀起回顾整年</p> -->
                        <h2>让距离更短，让营销更精准</h2>
                        <p>聚集跨平台，全垂类，红人资源，一站完成达人挑选。优质投放，先人一步，有评价，更可靠，好口碑，更信赖。需求分析-策略输出-红人优选-投放执行-监测优化，专业更值得依赖。</p>
                        <!--  -->
                    </div>
                    <div class="login" :class="isInto ? 'login_into' : 'login_out'">
                        <h1>观星数据平台</h1>
                        <el-form label-position="top" label-width="80px" :model="user" :rules="rules" ref="form">
                            <el-form-item label="用户账号" prop="name">
                                <el-input v-model="user.name" class="login_input"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input v-model="user.password" type="password" class="login_input"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox label="记住密码" v-model="user.savePassword"></el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="to_login" @click="onSubmit(user)">登 录</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="box_line_1"></div>
                        <div class="box_line_2"></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    name: '',
                    password: '',
                    savePassword: false
                },
                isInto: false,
                rules: {
                    name: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            onSubmit(data) {
                // console.log(data)
                // this.$router.push('/list')
                // return

                const loginInfo = {
                    u: data.name,
                    k: data.password
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$api.login.login(loginInfo).then(async res => {
                            console.log(res)
                            if (res.data.code === 0 && res.data.data.name) {
                                localStorage.setItem('api_token', res.data.data.token)
                                localStorage.setItem('uid', res.data.data.uid)
                                localStorage.setItem('deviceid', res.data.data.device)
                                localStorage.setItem('name', res.data.data.name)
                                localStorage.setItem('inSalesGroup', res.data.data.inSalesGroup)
                                sessionStorage.setItem('uid', res.data.data.uid)
                                sessionStorage.setItem('name', res.data.data.name)
                                sessionStorage.setItem('inSalesGroup', res.data.data.inSalesGroup)
                                localStorage.setItem('gx_centername', res.data.data.centername)
                                if (data.savePassword) {
                                    localStorage.setItem('user', data.name)
                                    localStorage.setItem('password', data.password)
                                }
                                localStorage.setItem('auth', JSON.stringify(res?.data?.data?.auth || {}))
                                let auth = JSON.parse(localStorage.getItem('auth')) || {}
                                this.$store.commit('AUTH', auth)
                                this.$cookies.set("authsign",res.data.data.authsign ,'1m', null, "changwankeji.com");
                                this.$router.push('/list')
                            }
                            if (res.data.code !== 0) {
                                this.$message.error(res.data.error);
                            }

                            // 登录埋点
                            let logParams = { type: 1 }
                            this.$api.setUseLog(logParams)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                // this.$router.push('/list')
            },
            login_box() {
                this.isInto = !this.isInto
            }
        },
        created() {
            if (localStorage.getItem('user')) {
                this.name = localStorage.getItem('user')
                this.password = localStorage.getItem('password')
                this.savePassword = true
            }
        }
    }
</script>

<style scoped>
    .background {
        top: 0;
        left: 0;
        position: absolute;
        z-index: 0;
        background: #000;
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
    }

    .background .video_group {
        margin-left: 12px;
    }

    .background .video_group:nth-child(3n) {
        margin-top: -413px;
    }

    .background .video_group:nth-child(3n-1) {
        margin-top: -261px;
    }


    .background .video {
        position: relative;
        margin: 10px 0;
        width: 306px;
        height: 544px;
        border-radius: 20px;
        /* background: blueviolet; */
    }

    .background .video img {
        display: block;
        object-fit: cover;
        width: 306px;
        height: 544px;
        border-radius: 20px;
    }

    .background .video video {
        width: 306px;
        height: 544px;
        border-radius: 20px;
        object-fit: cover;
    }

    .black {
        top: 0;
        left: 0;
        position: absolute;
        z-index: 10;
        background: rgba(0, 0, 0, 0.9);
        width: 100%;
        height: 100%;
    }

    .login_page {
        position: relative;
        z-index: 12;
        width: 100%;
        height: 100%;
    }

    .login_page .head {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 120px;
    }

    .login_page .head .head_c {
        width: 90%;
        min-width: 1200px;
        display: flex;
        justify-content: space-between;
    }

    .login_page .head .login_btn {
        width: 107px;
        height: 37px;
        background: none;
        border: 1px solid #BABABA;
        border-radius: 4px;
        font-size: 16px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
            "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 35px;
        cursor: pointer;
    }

    .login_page .head .login_btn:hover {
        color: #FF6F28;
        border: 1px solid #FF6F28;
    }

    .content {
        margin: 0 auto;
        width: 80%;
        box-sizing: border-box;
        padding-top: 150px;
        height: 100%;
        min-width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .content .info_login {
        display: flex;
        align-content: center;
        width: 100%;
        height: 500px;
        position: relative;
    }

    .info_login .info {
        width: 780px;
        margin-right: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 60;
        margin-right: auto;
    }

    .info_login .info h2 {
        width: 780px;
        font-size: 60px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
            "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 32px;
    }

    .info_login .info p {
        width: 770px;
        font-size: 20px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
            "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 32px;
        opacity: 0.4;
    }

    .info_login .login {
        width: 440px;
        min-width: 440px;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px #D7D7D7;
        border-radius: 14px;
        padding: 50px;
        box-sizing: border-box;
        position: absolute;
        z-index: 100;
        right: 0;
        transition: all 0.5s;
    }

    .info_login .login .box_line_1 {
        position: absolute;
        bottom: 2px;
        left: 0;
        background: #FFFFFF;
        height: 20px;
        width: 100%;
        border-radius: 14px;
        /* border-bottom: 1px solid #D7D7D7; */
        box-shadow: 0px 1px 0px 0px #D7D7D7;
    }

    .info_login .login .box_line_2 {
        position: absolute;
        bottom: 4px;
        left: 0;
        background: #FFFFFF;
        height: 20px;
        width: 100%;
        border-radius: 14px;
        /* border-bottom: 1px solid #D7D7D7; */
        box-shadow: 0px 1px 0px 0px #D7D7D7;
    }

    .info_login .login h1 {
        margin-block-start: 0
    }

    .info_login .login_into {
        top: 0px;
        opacity: 1;
    }

    .info_login .login_out {
        top: -800px;
        opacity: 0;
    }

    .info_login .login h1 {
        font-size: 28px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
            "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: bold;
        color: #333333;
        line-height: 32px;
    }

    .info_login .login>>>.el-form--label-top .el-form-item__label {
        font-size: 14px;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
            "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-weight: 500;
        color: #333333;
        line-height: 32px;
    }

    .login_input>>>.el-input__inner {
        border: 1px solid #DFDFDF;
        border-radius: 8px;
        height: 52px;
        line-height: 52px;
    }

    .login_input>>>.el-input.is-active .el-input__inner,
    .login_input>>>.el-input__inner:focus {
        background: #FFFFFF;
        border: 1px solid #FF6F28;
        box-shadow: 0px 0px 0px 2px #FFF3ED, 0px 0px 0px 2px #FFF3ED;
        border-radius: 8px;
    }

    .login>>>.el-form-item:nth-last-of-type(1) {
        margin-bottom: 0;
    }

    .to_login {
        padding: 0;
        width: 100%;
        height: 60px;
        background: #FF6F28;
        border-radius: 8px;
        font-size: 20px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 59px;
        text-align: center;
        border: none;
        cursor: pointer;
    }

    .to_login:hover {
        background: #f15102;
    }
</style>